export default __webpack_public_path__ + "static/media/LegendaHome.ccbf80da.svg";